<template>
    <b-modal size="lg" ref="modalAssocia" id="modalAssociaSim" title="Associa Sim" scrollable centered>
        <div class="sa-list-component-header" style="padding-top: 5px">
            <div class="sa-page-search-component">
                <b-form style="width: 100%" @submit.prevent="onSubmit">
                    <b-row class="sa-form-btn-filter">
                        <b-col xs="6" sm="6" md="12" lg="12" xl="12">
                            <label class="sa-label-data">Gestore</label>
                            <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                <input class="sa-page-search-component-input" v-model="mdlFiltroSim.gestore" placeholder="Inserisci gestore sim.." />
                            </div>
                            <button class="sa-page-search-component-btn-search" title="Search">
                                <i class="fas fa-search"></i>
                            </button>
                            <button class="sa-page-search-component-btn-reset" @click="resetmdlFiltroSim" type="button"><i class="fas fa-trash"></i></button>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
        </div>
        <div class="b-table-sticky-header">
            <b-table sticky-header :busy="isBusy" ref="table" stacked="lg" striped hover :items="items" :fields="fieldsModal" sort-icon-left head-variant="light" class="sa-b-table" current-page="1" :per-page="perPageUsers">
                <template #table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Caricamento...</strong>
                    </div>
                </template>
                <template #cell(firstname)="row">
                    <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                </template>
                <template v-slot:cell(checkBox)="{ item }">
                    <b-form-checkbox v-model="item.check" size="md" switch class="sa-normal-label"> </b-form-checkbox>
                </template>
                <template #cell(action)="row">
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!row.item.check" size="md" variant="outline-success" class="btn-sim" @click="onAssocia(row.item)">
                            <b-icon icon="person-check-fill" aria-hidden="true"></b-icon>
                            Associa
                        </b-button>
                        <b-button v-else variant="outline-danger" size="md" class="btn-sim" @click="onDeleteAssociazione(row.item)">
                            <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                            Dissocia
                        </b-button>
                    </div>
                </template>
            </b-table>
        </div>

        <template #modal-footer="{ ok }">
            <b-button size="sm" variant="outline-danger" @click="ok()">
                <b-icon icon="x"></b-icon>
                Annulla
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    components: {},
    mixins: [UtilityMixin],
    data() {
        return {
            isBusy: false,
            showModalLoading: false,
            perPage: 10,
            perPageUsers: 100000,
            currentPage: 1,
            currentPageUsers: 1,
            pathResource: "/devicesim",
            pathResourceDeviceSim: "/devicedevicesim",
            mdlFiltroSim: {
                gestore: "",
            },
            obj: {},
            items: [],
            associazioni: [],

            fieldsModal: [
                {
                    label: "",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Gestore",
                    key: "gestore",
                    sortable: true,
                },
                {
                    label: "Numero",
                    key: "numero",
                    sortable: true,
                },
                {
                    label: "",
                    key: "action",
                    tdClass: "text-right",
                },
            ],
        };
    },
    created: function () {},
    methods: {
        init(idDevice) {
            let me = this;
            me.idDevice = idDevice;
            me.show();
        },
        show() {
            let me = this;
            me.associazioni = [];
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;
            let mdlFiltroSim = sessionStorage.getItem("mdlFiltroSim");
            if (mdlFiltroSim) {
                me.mdlFiltroSim = JSON.parse(mdlFiltroSim);
            }
            me.loadData(me.mdlFiltroSim);
            me.$refs.modalAssocia.show();
            me.loadDataDeviceSim();
        },
        loadData(filtro) {
            let me = this;
            me.loadDataResources(me.pathResource, filtro, me.resultResponseData, me.resultErrorData);
        },
        resultResponseData(response) {
            let me = this;
            me.items = [];
            me.items = response.data.data.list;
            me.mergeAssociazioni();
        },
        resultErrorData(error) {
            let messaggio = error.response.data.messaggio;
            console.log(messaggio);
        },
        onAssocia(item) {
            let me = this;
            let esisteGia = me.associazioni.some((associazione) => associazione.idSim === item.id);
            if (esisteGia) {
                return;
            }
            let obj = {
                id: null,
                idSim: item.id,
                idDevice: me.idDevice,
            };
            me.associaSim(obj);
        },
        associaSim(obj) {
            let me = this;
            obj.statoAttuale = "ATTIVO";
            obj.statoAttualeDataOra = new Date().getTime();
            me.saveResource(me.pathResourceDeviceSim, obj, me.resulResponseSave, null);
        },
        resulResponseSave(response) {
            let me = this;
            me.$refs["modalAssocia"].hide();
            response.data.data;
            me.showModalLoading = false;
            me.$emit("afterSave");
            this.$bvToast.toast("Sim Associata", {
                title: this.getLabelTraduora("ambulatory.toastAssociateUserSuccess"),
                solid: true,
                variant: "success",
                autoHideDelay: 1000,
                appendToast: true,
            });
        },
        onDeleteAssociazione(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm(this.getLabelTraduora("ambulatory.modelMessageConfirmDeleteAssociate"), {
                    title: this.getLabelTraduora("ambulatory.modelMessageDeleteAssociate"),
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteAssociazione(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        deleteAssociazione(item) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDeviceSim + "/";
            axios
                .delete(link + item.idAssociazione)
                .then((response) => {
                    console.log(response);
                    me.showModalLoading = false;
                    me.mergeAssociazioni();
                    me.show();
                    me.$refs["modalAssocia"].hide();
                })
                .catch((error) => {
                    console.log(error);
                    me.showModalLoading = false;
                });
        },
        resetmdlFiltroSim() {
            let me = this;
            me.mdlFiltroSim.gestore = "";
            me.loadData(me.mdlFiltroSim);
        },
        loadDataDeviceSim() {
            let me = this;
            me.loadDataResources(me.pathResourceDeviceSim, { idDevice: me.idDevice }, me.resultDeviceSim, me.resultErrorDeviceSim);
        },
        resultDeviceSim(response) {
            let me = this;
            me.associazioni = response.data.data.list;
            me.mergeAssociazioni();
        },
        resultErrorDeviceSim(error) {
            console.log(error);
        },
        mergeAssociazioni() {
            let me = this;

            if (!me.items.length) {
                return;
            }

            me.items = me.items.map((item) => {
                let associazione = me.associazioni.find((associazione) => associazione.idSim === item.id);

                return {
                    ...item,
                    check: !!associazione,
                    idAssociazione: associazione ? associazione.id : null,
                };
            });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem("mdlFiltroSim", JSON.stringify(me.mdlFiltroSim));
            me.loadData(me.mdlFiltroSim);
        },
    },
};
</script>
<style scoped>
.btn-sim {
    min-width: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
